import React from "react";

export function formatTimezoneLabel(timeZoneId) {
  if (!timeZoneId) return "Local Time";
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: timeZoneId,
      timeZoneName: "longGeneric",
    }).formatToParts(new Date());
    const name = parts.find((p) => p.type === "timeZoneName")?.value;
    if (name) return name.replace(/\s+time$/i, " Time");
  } catch {
    /* fall through */
  }
  return `${timeZoneId.replace(/_/g, " ")} Time`;
}

export function GCalChevronLeft({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="M15.41 7.41 14 6l-6 6 6 6 1.41-1.41L10.83 12z" />
    </svg>
  );
}

export function GCalChevronRight({ size = 24 }) {
  return (
    <svg width={size} height={size} viewBox="0 0 24 24" aria-hidden="true" focusable="false">
      <path fill="currentColor" d="m10 6-1.41 1.41L13.17 12l-4.58 4.59L10 18l6-6z" />
    </svg>
  );
}

/** Google CalendarWebAppSlots icon button (month/day nav). */
export function GCalIconButton({ className = "", ariaLabel, onClick, children, disabled }) {
  return (
    <button
      type="button"
      className={`pYTkkf-Bz112c-LgbsSe pYTkkf-Bz112c-LgbsSe-OWXEXe-SfQLQb-suEOdc ${className}`.trim()}
      aria-label={ariaLabel}
      onClick={onClick}
      disabled={disabled}
    >
      <span className="XjoK4b pYTkkf-Bz112c-UHGRz" />
      <span className="UTNHae" />
      <span className="pYTkkf-Bz112c-kBDsod-Rtc0Jf">{children}</span>
      <span className="pYTkkf-Bz112c-RLmnJb" />
    </button>
  );
}

/** Google appointment time slot pill. */
export function GCalSlotButton({ onClick, children }) {
  return (
    <button
      type="button"
      className="AeBiU-LgbsSe AeBiU-kSE8rc-FoKg4d-sLO9V-YoZ4jf NhEBKc"
      onClick={onClick}
    >
      <span className="XjoK4b AeBiU-UHGRz" />
      <span className="UTNHae" />
      <span className="AeBiU-kBDsod-Rtc0Jf AeBiU-kBDsod-Rtc0Jf-OWXEXe-M1Soyc" />
      <span className="AeBiU-vQzf8d">{children}</span>
      <span className="AeBiU-kBDsod-Rtc0Jf AeBiU-kBDsod-Rtc0Jf-OWXEXe-UbuQg" />
    </button>
  );
}

export function GCalPopupBookButton({ onClick, disabled, children }) {
  return (
    <button type="submit" className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-k8QpJ nCP5yc AjY5Oe LQeN7 gcal-popup-book-native" disabled={disabled} onClick={onClick}>
      <span className="VfPpkd-vQzf8d">{children}</span>
    </button>
  );
}

export function GCalPopupCancelButton({ onClick, children }) {
  return (
    <button type="button" className="VfPpkd-LgbsSe VfPpkd-LgbsSe-OWXEXe-ksKsZd-UbuQg bhy0Kf e3Du3d gcal-popup-cancel-native" onClick={onClick}>
      <span className="VfPpkd-vQzf8d">{children}</span>
    </button>
  );
}
